export default "__VITE_ASSET__DG1Q_tOR__"